import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UploadArtwork from '../Images/UploadArtwork.png';
import edit from '../Images/edit-text.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { Pagination, Autoplay } from 'swiper/modules';

const CurrentOrders = ({ token }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedRow, setExpandedRow] = useState(null); 
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null); 
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [filesToUpload, setFilesToUpload]     = useState({ file1: null, file2: null });
  const [uploadError, setUploadError] = useState({});

  const [uploadErrorMessage, setUploadErrorMessage] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

// errors & spinner you already have:

  const navigate = useNavigate();

    const fetchCurrentOrders = async () => {
      setLoading(true);
      try {
        const response = await fetch("https://backend.printtrio.co.uk/api/order/current", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();

        if (data.success && data.data) {
          setOrders(data.data || []);
        } else {
          setOrders([]);
        }
      } catch (err) {
        setError("An error occurred while fetching orders.");
      } finally {
        setLoading(false);
      }
    };
    useEffect(() => {

    if (token) {
      fetchCurrentOrders();
    }
  }, [token]);

  const handleShopNowClick = () => {
    navigate("/");
  };

  const toggleExpandRow = (id) => {
    setExpandedRow(expandedRow === id ? null : id);
  };

  const handleDeleteItem = async (itemId, orderId) => {
    try {
      const response = await fetch(`https://backend.printtrio.co.uk/api/order/delete-order-item/${itemId}`, {
        method: 'DELETE',
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });
      const data = await response.json();

      if (data.success) {
        await fetchCurrentOrders();
      } else {
        console.error("Failed to delete the item:", data.errors || data.message);
      }
    } catch (err) {
      console.error("Error deleting item:", err);
    } finally {
      // Close the modal after processing
      setShowConfirmModal(false);
      setSelectedItem(null);
    }
  };

  const openConfirmModal = (itemId, orderId) => {
    setSelectedItem({ itemId, orderId });
    setShowConfirmModal(true);
  };


  const handleEditClick = (id, productId) => {
    // Navigate to '/product' and pass state
    navigate('/EditProductAfterPay', {   state: { 
      id,
      productId,
      fromSaved: true   
    } });
  };

  
  const uploadFiles = async (file1, file2, itemId) => { 
    const formData = new FormData();
    formData.append("file1", file1 || "");
    formData.append("file2", file2 || "");
  
    const res = await fetch(
      `https://backend.printtrio.co.uk/api/order/upload-file/${itemId}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    );
  
    const data = await res.json();
    if (res.ok && data.success) {
      // refresh your list here instead
      await fetchCurrentOrders();
    } else {
      // refresh your list so the new file1/url appears
      await fetchCurrentOrders();
    }
  };
  
    
    
    
    
    
    const handleFileChange = (e) => {
      const selectedFiles = e.target.files; // Get selected files
      setFilesToUpload({
        file1: selectedFiles[0] || null, // First selected file (if exists)
        file2: selectedFiles[1] || null, // Second selected file (if exists)
      });
    };
    
    
    
    const handleUploadFiles = async () => {
      if (!filesToUpload.file1 && !filesToUpload.file2) {
        setUploadErrorMessage("Please select at least one file");
        return;
      }
      if (!selectedProduct) return;  // selectedProduct = the saved‐item’s id
    
      setIsUploading(true);
      await uploadFiles(
        filesToUpload.file1,
        filesToUpload.file2,
        selectedProduct      // ← this must be item.id from fetchCurrentOrders
      );
      await fetchCurrentOrders();
      setIsUploading(false);
      setShowUploadModal(false);
      setFilesToUpload({ file1: null, file2: null });
      
    };
  

  if (loading) {
    return (
      <div className="flex-grow p-10 bg-white mt-[3%] mb-[3%] mx-[5%] text-center py-10">
        Loading orders...
      </div>
    );
  }

  if (error) {
    return <div className="text-center py-10 text-red-500">{error}</div>;
  }

  // if (orders.length === 0) {
  //   return (
  //     <div className="flex flex-col justify-center items-center text-center">
  //       <p className="text-gray-500 text-sm mb-6">
  //         No active orders found. Check out our collection and start shopping!
  //       </p>
  //       <button
  //         className="bg-transparent text-[#EC008C] font-semibold border-2 border-[#EC008C] rounded-full px-6 py-3 hover:bg-[#EC008C] hover:text-white transition duration-300 flex items-center gap-2"
  //         onClick={handleShopNowClick}
  //       >
  //         Shop Now
  //         <svg
  //           xmlns="http://www.w3.org/2000/svg"
  //           className="h-5 w-5"
  //           fill="none"
  //           viewBox="0 0 24 24"
  //           stroke="currentColor"
  //           strokeWidth={2}
  //         >
  //           <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
  //         </svg>
  //       </button>
  //     </div>
  //   );
  // }

  return (
    <div className="flex-grow p-10 bg-white mt-[3%] mb-[3%] mx-[0%] rounded-md overflow-x-auto">
      {orders.length === 0 ? (
        // No Orders Found View
        <div className="flex items-center justify-center min-h-[50vh] w-full">
        <div className="text-center">
          <p className="text-gray-500 text-sm mb-6">
            No active orders found. Check out our collection and start shopping!
          </p>
          <button
            className="bg-transparent text-[#EC008C] font-semibold border-2 border-[#EC008C] rounded-full px-6 py-3 hover:bg-[#EC008C] hover:text-white transition duration-300 flex items-center gap-2 mx-auto"
            onClick={handleShopNowClick}
          >
            Shop Now
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
      
      
      ) : (
       
        <div className="">
        <table className="w-full border-separate border-spacing-y-0">
          <thead>
            <tr className=" text-left">
              <th className="py-2 px-4">No</th>
              <th className="py-2 px-4">Payment Status</th>
              <th className="py-2 px-4">Created Date</th>
              <th className="py-2 px-4">Item</th>
              <th className="py-2 px-4">Price</th>
              <th className="py-2 px-4">Status</th>
              <th className="py-2 px-4 text-right">
                <span className="inline-block w-4 h-4"></span>
              </th>
            </tr>
          </thead>
          <tbody>
          {orders.map((order, idx) => {
   const isExpanded      = expandedRow === order.id;
  const orderId = order.id;
  const payment_status = order.payment_status;
  const createdDate = order.created_at
    ? new Date(order.created_at).toLocaleString()
    : "06 Oct 2023, 5:22";
  const itemCount = order.order_items.length || 1;
  const totalPriceValue = Number(order.total_price) || 0;
  const status = order.status;
  const paymentMethod = order.payment_method;

  return (
    <React.Fragment key={order.id}>
      <tr className="text-left bg-[#F1F8FE] rounded-lg">
        <td className="py-4 px-4 align-middle font-medium">
          {`#${orderId}`}
        </td>
        <td className="py-4 px-4 align-middle">{payment_status}</td>
        <td className="py-4 px-4 align-middle whitespace-nowrap">
          {createdDate}
        </td>
        <td className="py-4 px-4 align-middle">
          {itemCount} Item{itemCount > 1 ? "s" : ""}
        </td>
        <td className="py-4 px-4 align-middle">
          £{totalPriceValue.toLocaleString("en-GB", { minimumFractionDigits: 2 })}
          <br />
          <span className="text-black text-sm">{paymentMethod}</span>
        </td>
        <td className="py-4 px-0 align-middle">
          <span
            className={`font-semibold text-md px-0 py-1 rounded-lg ${
              status === "New"
                ? " text-blue-600 font-semibold"
              : status === "Pending_Payment"
                ? " text-amber-600 font-semibold"
              : status === "Processing"
                ? " text-indigo-600 font-semibold"
              : status === "In_production"
                ? " text-purple-600 font-semibold"
              : status === "On_hold"
                ? " text-orange-600 font-semibold"
              : status === "Dispatched"
                ? " text-teal-600 font-semibold"
              : status === "In_Cancelation"
                ? " text-red-600 font-semibold"
              : status === "Cancelled"
                ? " text-rose-600 font-semibold"
              : status === "Delivered"
                ? " text-lime-600 font-semibold"
              : status === "Completed"
                ? " text-green-600 font-semibold"
              : "text-gray-600 font-semibold"
            }`}
          >
            {status.replace(/_/g, " ")}
          </span>
        </td>
        <td className="py-4 px-4 align-middle text-right">
  <button onClick={() => toggleExpandRow(order.id)}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
      className={`h-5 w-5 inline-block transform transition-transform ${
        isExpanded ? 'rotate-180' : ''
      }`}
      fill="none"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 10l7 7 7-7"
      />
    </svg>
  </button>
</td>

      </tr>

      {isExpanded && (
        <tr className="bg-[#F1F8FE] rounded-md">
          <td colSpan="7" className="p-4">
            {order.order_items.map((item, idx) => {
              const isSample = item.free_sample_id === 1;
              const display = isSample ? item.free_sample : item.product;
              const priceValue = isSample
                ? parseFloat(display.price)
                : parseFloat(item.total_price_with_vat || 0);

              return (
                <div key={item.id || idx} className="flex flex-col justify-between gap-4 mb-5 mt-5">
                  <div className="flex gap-4">
                  <div className="relative w-24 h-24 flex-shrink-0">
  {isSample ? (
    // 1) Free sample
    <img
      src={`https://backend.printtrio.co.uk/${display.image}`}
      alt={display.name}
      className="w-full h-full rounded-md object-contain"
    />
  ) : (typeof item.file1 === 'string' && typeof item.file2 === 'string') ? (
    // 2) Both files → Swiper
    <Swiper
      modules={[Pagination, Autoplay]}
      pagination={{ clickable: true }}
      spaceBetween={10}
      slidesPerView={1}
      loop={false}
      autoplay={false}
      className="w-full h-full"
    >
      <SwiperSlide>
        <img
          src={item.file1}
          alt={display.name}
          className="w-full h-full rounded-md object-contain"
        />
      </SwiperSlide>
      <SwiperSlide>
        <img
          src={item.file2}
          alt={display.name}
          className="w-full h-full rounded-md object-contain"
        />
      </SwiperSlide>
    </Swiper>
  ) : typeof item.file1 === 'string' ? (
    // 3) Only file1 → single image
    <img
      src={item.file1}
      alt={display.name}
      className="w-full h-full rounded-md object-contain"
    />
  ) : (
    // 4) No files → placeholder
    <img
      src={UploadArtwork}
      alt="Upload artwork"
      className={`w-full h-full rounded-md object-contain ${
        (order.status === 'New' || order.status === 'Processing') &&
        item.free_sample_id !== 1
          ? 'cursor-pointer'
          : ''
      }`}
      onClick={() => {
        if (
          (order.status === 'New' || order.status === 'Processing') &&
          item.free_sample_id !== 1
        ) {
          setSelectedProduct(item.id);
          setShowUploadModal(true);
        }
      }}
    />
  )}

  {/* edit-icon on top of any real artwork */}
  {!isSample &&
    (typeof item.file1 === 'string' || typeof item.file2 === 'string') &&
    (order.status === 'New' || order.status === 'Processing') &&
    item.free_sample_id !== 1 && (
      <button
        onClick={() => {
          setSelectedProduct(item.id);
          setShowUploadModal(true);
        }}
        className="absolute top-1 right-1 w-5 h-5 z-10"
        title="Upload artwork"
      >
        <img src={edit} alt="Edit" className="w-full h-full object-cover" />
      </button>
    )}
</div>


                    <div className="text-sm text-gray-700 space-y-1">
  {/* Always show name */}
  <p  className="mt-9">
    <strong>{isSample ? 'Sample Pack:' : 'Product:'}</strong> {display.name}
  </p>

  {/* Non-sample details */}
  {!isSample && (
    <>
      <p><strong>Size:</strong> {item.size || 'N/A'}</p>
      <p><strong>Paper Weight:</strong> {item.paper_weight || 'N/A'}</p>
      <p><strong>Quantity:</strong> {item.quantity || 'N/A'}</p>

      {item.foiling_color && (
        <p><strong>Foiling Color:</strong> {item.foiling_color}</p>
      )}
      {item.spot_UV != null && (
        <p><strong>Spot UV:</strong> {item.spot_UV ? 'Yes' : 'No'}</p>
      )}
      {item.white_color != null && (
        <p><strong>White Color:</strong> {item.white_color ? 'Yes' : 'No'}</p>
      )}
      {item.lamination && (
        <p><strong>Lamination:</strong> {item.lamination}</p>
      )}
      {item.corner_cut_style && (
        <p><strong>Corner Cut Style:</strong> {item.corner_cut_style}</p>
      )}
      {item.orientation && (
        <p><strong>Orientation:</strong> {item.orientation}</p>
      )}
      {item.printed_side && (
        <p><strong>Printed Side:</strong> {item.printed_side}</p>
      )}
      {item.paper_type && (
        <p><strong>Paper Type:</strong> {item.paper_type}</p>
      )}

      <p>
        <strong>Description:</strong>{" "}
        {item.service_description?.trim() || 'No notes provided.'}
      </p>
    </>
  )}

  {/* Sample details */}
  {isSample && (
    <p>
      {/* <strong>Description:</strong> {display.description} */}
    </p>
  )}
</div>

                  </div>

                  <div className="flex justify-end items-center gap-5">
                    <div className="text-right text-black font-semibold">
                      £{priceValue.toLocaleString('en-GB', { minimumFractionDigits: 2 })}
                    </div>
                    <div
                      className={`font-semibold text-md px-3 py-1 rounded-lg ${
                        item.status === "New"
                          ? " text-blue-600 font-semibold"
                        : item.status === "Pending_Payment"
                          ? " text-amber-600 font-semibold"
                        : item.status === "Processing"
                          ? " text-indigo-600 font-semibold"
                        : item.status === "In_production"
                          ? " text-purple-600 font-semibold"
                        : item.status === "On_hold"
                          ? " text-orange-600 font-semibold"
                        : item.status === "Dispatched"
                          ? " text-teal-600 font-semibold"
                        : item.status === "In_Cancelation"
                          ? " text-red-600 font-semibold"
                        : item.status === "Cancelled"
                          ? " text-rose-600 font-semibold"
                        : item.status === "Delivered"
                          ? " text-lime-600 font-semibold"
                        : item.status === "Completed"
                          ? " text-green-600 font-semibold"
                        : " text-gray-600 font-semibold"
                      }`}
                    >
                      {item.status.replace(/_/g, " ")}
                    </div>
                  </div>

                  {( (order.status === "New" || order.status === "Processing")
                    && order.coupon_id === null
                    && item.free_sample_id !== 1
                  ) && (
                    <div className="flex items-center gap-4 text-sm">
                      {/* <button
                        onClick={() => handleEditClick(item.id, item.product_id)}
                        className="flex items-center gap-1 text-gray-700 hover:text-black"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-5M10 14l10-10M14 4l6 6" />
                        </svg>
                        Edit
                      </button> */}
                      {/* <button
                        onClick={() => openConfirmModal(item.id, order.id)}
                        className="flex items-center gap-1 text-red-600 hover:text-red-800"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V5a2 2 0 00-2-2H9a2 2 0 00-2 2v2m4 0h.01" />
                        </svg>
                        Delete
                      </button> */}
                    </div>
                  )}
                </div>
              );
            })}
          </td>
        </tr>
      )}
      {idx < orders.length - 1 && (
  <tr>
    <td colSpan="7" className="p-0 bg-white">
      <div className="h-4" />
    </td>
  </tr>
)}
      
    </React.Fragment>
  );
})}

          </tbody>
        </table>
      </div>
      
      )}
      {showUploadModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white w-full max-w-md p-6 rounded-lg shadow-lg">
      <h2 className="text-lg font-bold mb-4 text-center">Upload Files</h2>
      <p className="text-gray-600 mb-4 text-center">Upload the required files for this product.</p>

      <input
        type="file"
        multiple
        onChange={handleFileChange} // Handle file selection
        className="block w-full mb-4"
      />

      {uploadErrorMessage && (
        <p className="text-red-500 text-sm mb-4">{uploadErrorMessage}</p>
      )}

      <div className="flex justify-end space-x-4">
      {isUploading ? (
    // Show spinner during upload
    <div className="flex justify-center w-full">
      <svg
        className="animate-spin h-12 w-12 text-pink-500"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8H4z"
        />
      </svg>
    </div>
  ) : (
    <>
        <button
          className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600"
          onClick={() => setShowUploadModal(false)} // Close the modal
        >
          Cancel
        </button>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
          onClick={handleUploadFiles} // Trigger file upload
        >
          Upload
        </button>
        </>
  )}
      </div>
    </div>
  </div>
)}

{showConfirmModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <h2 className="text-lg font-bold mb-4">Confirm Delete</h2>
      <p>Are you sure you want to delete this item?</p>
      <div className="mt-6 flex justify-end space-x-4">
        <button
          className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          onClick={() => setShowConfirmModal(false)}
        >
          Cancel
        </button>
        <button
          className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          onClick={() => {
            handleDeleteItem(
              selectedItem.itemId,
              selectedItem.orderId
            );
          }}
        >
          Delete
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
  
};

export default CurrentOrders;
